import { MutationTree } from 'vuex'
import { TownMembership, ModuleState } from './types'
import { initialState } from './index'

export const mutations: MutationTree<ModuleState> = {
  handleFetchPending(state, { memberships, townId }: {memberships: TownMembership[]; townId: number}) {
    state.pending[townId] = memberships;
  },
  reset(state) { Object.assign(state, initialState) }
}
